import { StepDefinitionStrategy } from './step-definition.strategy';
import { Injectable } from '@angular/core';
import { AvailableStepsInNavigationBar, NavigationBarItem, RouteIds, Step } from '../../types';
import { BaseStepDefinitionStrategy } from './base-step-definition.strategy';
import { customizeQuoteStepNavigationBarItem } from '../../utils';
import { GoogleAnalyticsEventEnum } from '../../google-analytics';
import { Flows, Flow } from '@lx/quote-tool/lite/shared/types';

@Injectable({
  providedIn: 'root',
})
export class ApplicantStepDefinitionService extends BaseStepDefinitionStrategy implements StepDefinitionStrategy {
  private stepDefinition: Step = {
    id: RouteIds.applicant,
    title: $localize`We are ready for you!`,
    googleAnalyticsEvent: GoogleAnalyticsEventEnum.Applicant,
  };

  getStepDefinition(activeFlow: Flow) {
    return {
      ...this.stepDefinition,
      nextStep: () => (activeFlow === Flows.Aya ? RouteIds.ayaQuote : RouteIds.quote),
      navigationBarItems: this.getNavigationBarItems(activeFlow),
    };
  }

  fillNavigationBarItemsProperties(
    baseNavigationBarItems: Record<AvailableStepsInNavigationBar, NavigationBarItem>,
    activeFlow: Flow,
  ): Record<AvailableStepsInNavigationBar, NavigationBarItem> {
    const filledNavigationBarItems = { ...baseNavigationBarItems };

    filledNavigationBarItems[RouteIds.course] = {
      ...filledNavigationBarItems[RouteIds.course],
      icon: 'check',
    };

    if (activeFlow !== 'online') {
      filledNavigationBarItems[RouteIds.extras] = {
        ...filledNavigationBarItems[RouteIds.extras],
        icon: 'check',
      };
    }

    return {
      ...filledNavigationBarItems,
      ...customizeQuoteStepNavigationBarItem(activeFlow, filledNavigationBarItems),
    };
  }
}
